module.exports = __webpack_public_path__ + "static/media/kaju_mango.f634b590.jpg";